export default {
  upper: {
    name: "Uppercase Letters",
    guideline: 37,
    symbols: [
      { character: "A", guideline: 26 },
      { character: "B" },
      { character: "C" },
      { character: "D" },
      { character: "E" },
      { character: "F" },
      { character: "G", guideline: 32 },
      { character: "H" },
      { character: "I", letterWidth: 50 },
      { character: "J" },
      { character: "K" },
      { character: "L" },
      { character: "M", letterWidth: 100 },
      { character: "N" },
      { character: "O" },
      { character: "P", guideline: 33 },
      { character: "Q" },
      { character: "R" },
      { character: "S" },
      { character: "T" },
      { character: "U" },
      { character: "V" },
      { character: "W", letterWidth: 110 },
      { character: "X" },
      { character: "Y" },
      { character: "Z" },
    ],
  },
  lower: {
    name: "Lowercase Letters",
    guideline: 52,
    symbols: [
      { character: "a" },
      { character: "b" },
      { character: "c" },
      { character: "d" },
      { character: "e" },
      { character: "f", guideline: 48 },
      { character: "g" },
      { character: "h" },
      { character: "i" },
      { character: "j" },
      { character: "k" },
      { character: "l" },
      { character: "m" },
      { character: "n" },
      { character: "o" },
      { character: "p" },
      { character: "q" },
      { character: "r" },
      { character: "s" },
      { character: "t", guideline: 48 },
      { character: "u" },
      { character: "v" },
      { character: "w" },
      { character: "x" },
      { character: "y" },
      { character: "z" },
    ],
  },
  numbers: {
    name: "Numbers",
    guideline: 37,
    symbols: [
      { character: "1" },
      { character: "2" },
      { character: "3" },
      { character: "4", guideline: 21 },
      { character: "5", guideline: 42 },
      { character: "6", guideline: 42 },
      { character: "7" },
      { character: "8", guideline: 39 },
      { character: "9", guideline: 28 },
      { character: "0" },
    ],
  },
};
